import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const FreshdeskIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props} customFill={preserveColor}>
    <g clipPath="url(#freshdesk-a)">
      <path
        fill="#25C16F"
        d="M15.963 4h9.013A3 3 0 0 1 28 7.027v9.01C28 22.646 22.646 28 16.038 28h-.069A11.96 11.96 0 0 1 4 16.04C4 9.415 9.345 4.069 15.963 4Z"
      />
      <path
        fill="#fff"
        d="M15.963 9.346a5.495 5.495 0 0 0-5.496 5.495v3.736a1.87 1.87 0 0 0 1.828 1.828h1.554v-4.293h-2.1v-1.2a4.268 4.268 0 0 1 4.261-4.027 4.262 4.262 0 0 1 4.257 4.027v1.2h-2.13v4.296h1.405v.068a1.713 1.713 0 0 1-1.688 1.688h-1.677c-.136 0-.287.068-.287.204a.3.3 0 0 0 .287.286h1.688a2.195 2.195 0 0 0 2.181-2.181v-.137a1.8 1.8 0 0 0 1.405-1.772v-3.652c.068-3.095-2.387-5.563-5.496-5.563l.008-.003Z"
      />
    </g>
    <defs>
      <clipPath id="freshdesk-a">
        <path fill="#fff" d="M4 4h24v24H4z" />
      </clipPath>
    </defs>
  </BaseIcon>
);
